import { render } from "./NewElementForm.vue?vue&type=template&id=909700d8"
import script from "./NewElementForm.vue?vue&type=script&lang=js"
export * from "./NewElementForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__